import { ChannelData } from "./ChannelData"

export class DeviceData {
    deviceId: string = ""
    channels: ChannelData[] = []

    constructor(init?: Partial<DeviceData>) {
        if (!init) {
            return
        }

        Object.assign(this, init)

        if (init.channels) {
            this.channels = init.channels.map(ch => new ChannelData(ch))
        }
    }
}